import React, {useState, useEffect} from 'react';
import { getDocs , collection , db , setDoc , doc , deleteDoc } from '../../firebase';
import SideBar from '../components/Sidebar';
import sidebar_menu from '../components/sidebar-menu';


function Experinces (  ) {
  
    const [ experinceArray , setExperincesArray ] = useState([]);

    const [addShow , setAddShow] = useState(false);
    const [showTable , setTableShow] = useState(true);

    const [updateShow , setUpdateShow] = useState(false);
    const [ deleteShow , setDeleteShow] = useState(false);

    const [success , setSuccess ] = useState(false);

    const [error , setError ] = useState('');

     // main experinces

    const [ experinceName , setExperinceName ] = useState('');
    const [ experincePrice , setExperincePrice ] = useState('');

    const [experinceDesc , setExperinceDesc ] = useState('');
    const [ experinceMap , setExperinceMap ] = useState('');
    const [ experinceOverview , setExperinceOverview ] = useState('');



    
    // photo url
    const [placePhotos , setPlacePhotos ] = useState([]);
    const [photoUrl , setPhotoUrl] = useState('');


    const [ experinceId , setExperinceId ] = useState('');


    const makeid = (length) =>  {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    const pushIntoPhotos = ( param ) => {

      setPlacePhotos(oldArray => [...oldArray, param]);
      setPhotoUrl('');
     
    }

   
    
  useEffect(  () => {

    const getExperincesData = async () => { 
      const querySnapshot = await getDocs(collection(db, "experiences"));
      const experincesdataarray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setExperincesArray(experincesdataarray);
     
    }
    getExperincesData();
  } , []);



    const addNewExperince =  async (e) => {

        e.preventDefault();



        if (experinceName === ''  ) {
          setError(' يرجى ادخال اسم التجربة ');
    }
    
    if (experinceDesc === ''  ) {
    setError('  يرجى ادخال وصف التجربة  ');
    }
    
    if (experinceOverview === ''  ) {
    setError('  يرجى ادخال نظرة عامة عن التجربة  ');
    }
    
  
    
    if (experincePrice === ''  ) {
    setError('  يرجى ادخال سعر التجربة  ');
    }
    
    if (experinceMap === ''  ) {
    setError('  يرجى ادخال ماب التجربة  ');
    }
    

    
        if (experinceName !== '' && experinceDesc !== '' && experinceOverview !== '' && experincePrice && experinceMap !== '' ) {

            const experiences = await setDoc(doc(db, "experiences", makeid(20)), {

              experince_name: experinceName,
              experince_price: experincePrice,
              experince_desc: experinceDesc,
              experince_overview: experinceOverview,
              experince_photos : placePhotos,
              experince_map: experinceMap,
             
              });

            
                setSuccess(true);
                setError('');

                setTimeout(() => {
                    setSuccess('');
                    window.location.reload();
                } , 1350);

             

        }
    }

    const updateShownMethod = ( name , desc , price , overview , detials  , map , id ) => {

        setExperinceName(name);
        setExperinceDesc(desc);
        setExperincePrice(price);
        setExperinceOverview(overview);
        setExperinceMap(map);

        setExperinceId(id);
    
    
    
        determineShow('update');
      }

      const deleteShowMethod = ( ) => {

            
        determineShow('delete');
      }

    const determineShow = ( param ) => {

        switch(param) {
            
            case 'show':
                setExperinceName('');
                setExperinceDesc('');
                setExperincePrice('');
                setExperinceOverview('');
                setExperinceMap('');
                setTableShow(true);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(false);
                break;

            case 'update':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(true);
                setDeleteShow(false);
                break;

            case 'delete':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(true);
                break;

            case 'add':
                setTableShow(false);
                setAddShow(true);
                setUpdateShow(false);
                setDeleteShow(false);
                break;
        }
    }

    const updateRecord = async (e) => {
        e.preventDefault();
        const docRef = doc(db, "experiences", experinceId);
    
    const data = {

      experince_name: experinceName,
      experince_price: experincePrice,
      experince_desc: experinceDesc,
      experince_overview: experinceOverview,
      // experince_photos : placePhotos,
      // experince_sections: placeSections,
      experince_map: experinceMap,
    };
    

    if (experinceName === ''  ) {
      setError(' يرجى ادخال اسم التجربة ');
}

if (experinceDesc === ''  ) {
setError('  يرجى ادخال وصف التجربة  ');
}

if (experinceOverview === ''  ) {
setError('  يرجى ادخال نظرة عامة عن التجربة  ');
}




if (experincePrice === ''  ) {
setError('  يرجى ادخال سعر التجربة  ');
}

if (experinceMap === ''  ) {
setError('  يرجى ادخال ماب التجربة  ');
}

    if (error === '') {
        setDoc(docRef, data)
    
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
    }

  
    
    
      }

      const deleteRecord = async (e) => {
        e.preventDefault();
      
        await deleteDoc(doc(db, "experiences", experinceId));
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
      }
  
      
   

    return(
      <div className="main_admin">

    <div className="sidebar_admin">
    <SideBar menu={sidebar_menu} />
    </div>

    <div className="content_admin">
    <div className='dashboard-content'>
            

            <div className='dashboard-content-container'>

            {addShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >اضافة مكان للموقع  </h2>
                <div className='dashboard-content-search'>
                    
                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع المواقع</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={addNewExperince} >

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم التجربة </label>
               
                <input value={experinceName} onChange={ (e) => setExperinceName(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف التجربة </label>
               
                <input value={experinceDesc} onChange={ (e) => setExperinceDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> سعر التجربة </label>
               
                <input type="number" value={experincePrice} onChange={ (e) => setExperincePrice(e.target.value)  } id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> نظرة عامة عن التجربة </label>
               
                <input type="text" value={experinceOverview} onChange={ (e) => setExperinceOverview(e.target.value)  } id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

      




            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   صور المكان </label>
               
                <input value={photoUrl} onChange={ (e) => setPhotoUrl(e.target.value)  } type="text" id='name' className="input_form" placeholder=' اضافة صور للمكان...' />

                <div className="dashbord-header-btn_2 w-80 mt-1" onClick={() => pushIntoPhotos(photoUrl) } >اضافة الصورة</div>

            </div>

         


            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   موقع المكان </label>
               
                <input required value={experinceMap} onChange={ (e) => setExperinceMap(e.target.value)  } type="text" id='name' className="input_form" placeholder='موقع المكان...' />
            </div>



     

            <button  type='submit' className="dashbord-header-btn_2 w-80">اضافة العلامة</button>


            </form>
                </>

            )}
            
            {updateShow && (
              <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >اضافة مكان للموقع  </h2>
                <div className='dashboard-content-search'>
                    
                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع المواقع</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={updateRecord} >

                <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم التجربة </label>
               
                <input value={experinceName} onChange={ (e) => setExperinceName(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف التجربة </label>
               
                <input value={experinceDesc} onChange={ (e) => setExperinceDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> سعر التجربة </label>
               
                <input type="number" value={experincePrice} onChange={ (e) => setExperincePrice(e.target.value)  } id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> نظرة عامة عن التجربة </label>
               
                <input type="text" value={experinceOverview} onChange={ (e) => setExperinceOverview(e.target.value)  } id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

          




            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   صور المكان </label>
               
                <input value={photoUrl} onChange={ (e) => setPhotoUrl(e.target.value)  } type="text" id='name' className="input_form" placeholder=' اضافة صور للمكان...' />

                <div className="dashbord-header-btn_2 w-80 mt-1" onClick={() => pushIntoPhotos(photoUrl) } >اضافة الصورة</div>

            </div>



            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1">   موقع المكان </label>
               
                <input required value={experinceMap} onChange={ (e) => setExperinceMap(e.target.value)  } type="text" id='name' className="input_form" placeholder='موقع المكان...' />
            </div>




     

            <button  type='submit' className="dashbord-header-btn_2 w-80">تعديل التجربة </button>



     

            <button  type='submit' className="dashbord-header-btn_2 w-80">تعديل الموقع</button>


            </form>
                </>

            )}
            
            {deleteShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' > حذف العلامة </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع التجارب</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={deleteRecord} >

              
          

            <button className="dashbord-header-btn_2 w-80 bg_red" type='submit'  >حذف التجربة</button>


            </form>
                </>

            )}

            {showTable && (
                <>
                <div className='dashboard-content-header'>
                    <h2 className='admin_headline' >قائمة التجارب السياحية </h2>
                    <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('add') } >  اضافة نجربة جديد</button>
                    </div>   
                   
                </div>

                {experinceArray && (
                    <table className='admin_table_dashboard' >
                    <thead>
                        
                        <th className='table_item' >اسم التجربة</th>
                        <th className='table_item'>صورة التجربة</th>
                        <th className='table_item'>سعر التجربة</th>

                        <th className='table_item'>التعديل \ الحذف</th>

                    </thead>

                    <tbody>

                        {experinceArray.map((item , i) => (
                            <tr key={i} >

                         
                            <td className='table_item_sm' > {item.experince_name} </td>
                            <td    > 
                                <img src={item.icon} alt="" className="icon_big" />
                             </td>
                            <td    > 
                              {item.experince_price}
                             </td>

                          
                            <td className='d-flex-c' >

                            <button className="edit_btn_admin" onClick={() => updateShownMethod(  item.name , item.subheadline , item.map  , item.heroarea , item.id   )  }  >تعديل</button>

                            <button className="delete_btn_admin" onClick={() => deleteShowMethod( ) } >حذف</button>
                            </td>

                        </tr>
                        ))}


                    </tbody>

               
                </table>
                )}

              
                </>
            )}
                
             

               
            </div>
        </div>
    </div>

        </div>

    )
}

export default Experinces;